export const products = [
  {
    id: 1,
    name: 'Main unit',
    href: '#',
    imageSrc: 'https://www.fyllo.in/img/app_product_display.png',
    imageAlt: "Front of men's Basic Tee in black.",
    price: '$35',
    color: 'Black',
  },
  {
    id: 2,
    name: 'Kairo',
    href: '#',
    imageSrc: 'https://www.fyllo.in/img/app_product_display.png',
    imageAlt: "Front of men's Basic Tee in black.",
    price: '$35',
    color: 'Black',
  },
  {
    id: 3,
    name: 'Nero',
    href: '#',
    imageSrc: 'https://www.fyllo.in/img/app_product_display.png',
    imageAlt: "Front of men's Basic Tee in black.",
    price: '$35',
    color: 'Black',
  },
];
